// @flow
import {
  ADD_CREDIT,
  SAVE_CREDIT,
  DELETE_CREDIT,
  EDIT_TRANSACTION
} from '../transaction/transaction.const.js';

export const payer = (state: $ElementType<ReduxState, 'payer'> = {}, action: Action) => {
  switch (action.type) {
    case ADD_CREDIT:
    case SAVE_CREDIT:
    case DELETE_CREDIT:
    case EDIT_TRANSACTION:
      return {
        ...state,
        balanceByOrg: action.payload.userBalancesByOrganizations || state.balanceByOrg
      };
    default:
      return state;
  }
};

export const user = (state: $ElementType<ReduxState, 'user'> = {}) => state;
export const users = (state: $ElementType<ReduxState, 'users'> = {}) => state;
